import {CustomEvent} from 'Utils/events';

if (typeof window.CustomEvent !== "function") {
  window.CustomEvent = CustomEvent;
}
